var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":10,"search":_vm.search,"loading":_vm.loading,"loading-text":'Chargement en cours...',"item-key":"_id","multi-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }